import React from 'react';
import Slider from 'react-slick';
import { alpha, useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';

const mock = [
    {
        newsTitle:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        avatar: 'https://assets.maccarianagency.com/backgrounds/img5.jpg',
    },
    {
        newsTitle:
            'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        avatar: 'https://assets.maccarianagency.com/backgrounds/img6.jpg',
    },
    {
        newsTitle:
            'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        avatar: 'https://assets.maccarianagency.com/backgrounds/img7.jpg',
    },
];

const LatestNews = () => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const sliderOpts = {
        dots: !isMd,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: isMd,
    };

    return (
        <Box
            sx={{
                position: 'relative',
                '&::after': {
                    position: 'absolute',
                    content: '""',
                    width: '30%',
                    zIndex: 1,
                    top: 0,
                    right: 0,
                    height: '100%',
                    backgroundSize: '18px 18px',
                    backgroundImage: `radial-gradient(${alpha(
                        theme.palette.primary.dark,
                        0.4,
                    )} 20%, transparent 20%)`,
                    opacity: 0.2,
                },
            }}
        >
            <Box position={'relative'} zIndex={2}>
                <Box marginBottom={4}>
                    <Typography
                        sx={{
                            textTransform: 'uppercase',
                            fontWeight: 'medium',
                        }}
                        gutterBottom
                        color={'secondary'}
                        align={'center'}
                    >
                        Latest News
                    </Typography>
                    <Typography
                        variant="h4"
                        align={'center'}
                        data-aos={'fade-up'}
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                            marginTop: theme.spacing(1),
                        }}
                    >
                        Our latest news
                    </Typography>
                    <Typography
                        variant="h6"
                        align={'center'}
                        color={'text.secondary'}
                        data-aos={'fade-up'}
                    >
                        Experience your music like never before. Buy music
                        instruments & accessories online.
                    </Typography>
                    <Box display="flex" justifyContent={'center'} marginTop={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                        >
                            Browse the blog
                        </Button>
                    </Box>
                </Box>
                <Box
                    sx={{
                        height: { xs: 'auto', md: 1 },
                        '& .slick-slide img': {
                            objectFit: 'cover',
                        },
                        '& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div':
                            {
                                height: { xs: 'auto', md: 1 },
                            },
                        '& .slick-prev, & .slick-next': {
                            zIndex: 2,
                            bottom: 0,
                            top: '100%',
                            left: '100%',
                            right: 0,
                            transform: `translate(-100%, calc(-100% - ${theme.spacing(
                                2,
                            )}))`,
                            marginLeft: theme.spacing(-2),
                            width: 32,
                            height: 32,
                            '&:before': {
                                fontSize: 32,
                                color: 'primary.main',
                            },
                        },
                        '& .slick-prev': {
                            marginLeft: theme.spacing(-7),
                        },
                    }}
                >
                    <Slider {...sliderOpts}>
                        {mock.map((item, i) => (
                            <Box key={i}>
                                <Card
                                    sx={{
                                        display: 'flex',
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        boxShadow: 0,
                                        background: 'transparent',
                                    }}
                                >
                                    <CardMedia
                                        image={item.avatar}
                                        sx={{
                                            height: 300,
                                            width: '100%',
                                            maxWidth: 400,
                                            borderRadius: 2,
                                            margin: {
                                                xs: '0 auto',
                                                md: 'none',
                                            },
                                        }}
                                    />
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginLeft: { sx: 0, md: 2 },
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                color="text.primary"
                                                variant={'h6'}
                                                sx={{
                                                    textAlign: {
                                                        xs: 'center',
                                                        md: 'left',
                                                    },
                                                }}
                                            >
                                                {item.newsTitle}
                                            </Typography>
                                            <Box
                                                marginTop={2}
                                                display={'flex'}
                                                justifyContent={{
                                                    xs: 'center',
                                                    md: 'flex-start',
                                                }}
                                            >
                                                <Button
                                                    endIcon={
                                                        <Box
                                                            component={'svg'}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                            width={24}
                                                            height={24}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={2}
                                                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                                                            />
                                                        </Box>
                                                    }
                                                >
                                                    Read More
                                                </Button>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        ))}
                    </Slider>
                </Box>
            </Box>
        </Box>
    );
};

export default LatestNews;
